import { render, staticRenderFns } from "./ironSourceIcon.vue?vue&type=template&id=7dc08e78&"
import script from "./ironSourceIcon.vue?vue&type=script&lang=js&"
export * from "./ironSourceIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports